<script>
import { Pie } from "vue-chartjs";
// import ChartJSPluginDatalabels from "chartjs-plugin-datalabels";
export default {
  extends: Pie,
  // plugins: [ChartJSPluginDatalabels],
  props: ["title", "data", "labels"],
  data() {
    return {};
  },
  mounted() {
    this.load();
  },
  watch: {
    data() {
      this.load();
    },
  },
  methods: {
    load() {
      this.renderChart(
        {
          labels: this.$props.labels,
          datasets: [
            {
              label: this.$props.title,
              backgroundColor: [
                "#FF0000",
                "#FF7F50",
                "#FFA500",
                "#FFFF00",
                "#90EE90",
                "#66CDAA",
                "#00FFFF",
                "#87CEEB",
                "#4169E1",
                "#0000FF",
              ],
              data: this.$props.data,
              datalabels: {
                display: false,
              },
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: "right",
          },
          // scales: {
          //   xAxes: [
          //     {
          //       ticks: {
          //         min: 0,
          //         // stepSize: 20000,
          //       },
          //     },
          //   ],
          // },
        }
      );
    },
  },
};
</script>
<style>
/* #pie-chart {
  width: 60vw;
  height: 80vh;
} */
</style>
